import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 3.7a.7.7 0 0 1 .7-.7h12.6a.7.7 0 0 1 .7.7v7.875h-1.4V7.55H4.4v8.05H11V17H3.7a.7.7 0 0 1-.7-.7V3.7Zm1.4 2.45h11.2V4.4H4.4v1.75Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M16.374 9.7a.7.7 0 0 1 .495.205l1.826 1.826a.7.7 0 0 1 0 .99l-4.929 4.929a.7.7 0 0 1-.412.2l-2.072.245a.7.7 0 0 1-.777-.777l.245-2.072a.7.7 0 0 1 .2-.412l4.929-4.929a.7.7 0 0 1 .495-.205Zm-4.262 5.952L12 16.6l.948-.112 4.262-4.262-.836-.836-4.262 4.262ZM12.754 9.487a.7.7 0 0 1 .036.99l-2.824 3.036a.7.7 0 0 1-1.025 0l-1.73-1.861a.7.7 0 1 1 1.024-.953l1.218 1.31 2.312-2.486a.7.7 0 0 1 .989-.036Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
